import { Dropdown, DropdownProps } from 'primereact/dropdown';
import { useTranslation } from 'react-i18next';

import { getAllLanguages, getLanguageByKey } from '@/languages';

type LocaleDropdownProps = DropdownProps & {
  className?: string;
  label?: string;
};

export const LocaleDropdown = ({
  className,
  label,
  ...dropdownProps
}: LocaleDropdownProps) => {
  const { i18n } = useTranslation();

  return (
    <div className={`locale-dropdown label-input-group ${className}`.trim()}>
      {label && <label>{label}</label>}
      <Dropdown
        value={getLanguageByKey(i18n.language ?? i18n.resolvedLanguage)?.value}
        options={getAllLanguages()}
        optionLabel="label"
        optionValue="value"
        onChange={(e) => i18n.changeLanguage(e.value)}
        {...dropdownProps}
      />
    </div>
  );
};
